import {get} from "lodash/object";
import {some} from "lodash/collection";

/**
 * Check if a role with the given ID exists in the user's roles array.
 *
 * @param {Object} user - The user object.
 * @param {number} roleId - The ID of the role to check.
 * @returns {boolean} Returns true if the role with the specified ID exists in the user's roles, otherwise false.
 */
export function checkIfUserHasRole(roleId, user) {
    /**
     * The "some()" function tests whether at least one element in the array passes the test implemented by the provided function.
     * @see {@link https://lodash.com/docs/4.17.15#some}
     */
    return some(get(user, 'roles', []), { id: roleId });
}
